<template>
  <div class="sm-messages">
    <div class="sm-messages__title">
      <h3>
        Send a message to {{ provider.name }}
      </h3>
      <span
          v-if="
            isMobile &&
            selectedMessage.id &&
            !selectedMessage.deleted &&
            selectedMessage.created_by.id === userAccount.id &&
            showDeleteIcon
          "
          @click="deleteSelectedMessage"
        >
          <include-svg :name="'icon-messages-delete'" />
        </span>
    </div>

    <div class="sm-messages__main">
      <div
        :class="[
          'sm-messages__main-messages width-100',
          {'customer': role === 'customer'}
        ]"
      >
        <div>
          <messages-list
            :key="selectedRoom.id"
            :selectedRoom="selectedRoom"
            :messagesObj="messages"
            :userAccount="userAccount"
            :isMobile="isMobile"
            :selectedMessage="selectedMessage"
            :endOfMessages="endOfMessages"
            :role="role"
            @selectMessage="selectMessage"
            @loadMore="loadMessages"
            @deleteSelectedMessage="deleteSelectedMessage"
          />
          <form-messages
            :role="role"
            :selectedRoom="selectedRoom"
            :isMobile="isMobile"
            @updateEverything="updateEverything"
            @callMethod="callMethod"
            @setShowSpinner="setShowSpinner"
          />
        </div>
      </div>
    </div>
    <popup-block
      v-if="selectedMessage.id && popup.isOpen"
      :open="popup.isOpen"
      :size="'large'"
      @close="popup.isOpen = false"
    >
      <template slot="popupContent">
        <confirm-block
          v-if="(popup.type = 'delete')"
          :title="'Delete message'"
          :text="`Are you sure you want to delete this message? This cannot be undone.`"
          :confirmType="'error'"
          @confirm="confirmDeleteSelectedMessage(selectedMessage)"
          @cancel="
            popup.isOpen = false;
            showDeleteIcon = false;
          "
        >
          <message-item
            :message="selectedMessage"
            :selectedMessage="selectedMessage"
            :isMobile="isMobile"
            :isAtConfirmBlock="true"
          />
        </confirm-block>
      </template>
    </popup-block>
    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Popup from "@/components/Popup";
import Confirm from "@/components/Confirm";
import Spinner from "@/components/Spinner";
import MessagesList from "@/views/common/pages/messages/components/MessagesList";
import MessageItem from "@/views/common/pages/messages/components/MessageItem";

import FormMessages from "@/components/forms/FormMessages";
import { userAccount } from '@/store/modules/account/getters';

export default {
  name: "messages",
  components: {
    "popup-block": Popup,
    "confirm-block": Confirm,
    "messages-list": MessagesList,
    "message-item": MessageItem,
    "form-messages": FormMessages,
    "sm-spinner": Spinner,
  },
  data() {
    return {
      role: "customer",
      selectedRoom: {
        customer: {
          id: userAccount.id,
          full_name: 'Your Operator',
        },
        isFaked: true
      },
      messages: {},
      selectedMessage: {},
      endOfMessages: false,
      showSpinner: false,
      pageLimit: {
        messages: 10,
      },
      showDeleteIcon: false, // for mobile
      popup: {
        isOpen: false,
        type: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      userAccount: "account/userAccount",
      clientFeatures: "general/clientFeatures",
      provider: "provider",
    }),
  },
  created() {
    this.showSpinner = true;
    this.getMessagingRoom().then((res) => {
      this.selectedRoom = res.messaging_room;
      this.showSpinner = false;
    })
    .catch(e => {
      console.log(e, e.response)
      this.showSpinner = false;
    });

  },
  methods: {
    ...mapActions({
      getMessagingRoom: "messages/getMessagingRoom",
      createNewRoom: "messages/createNewRoom",
      createNewMessage: "messages/createNewMessage",
      getMessagesList: "messages/getMessagesList",
      deleteMessage: "messages/deleteMessage",
      userData: "account/userData",
      getClientFeatures: "general/getClientFeatures"
    }),
    callMethod(method, callback, err, ...params) {
      if (!this[method]) return false;

      this[method](...params)
        .then((res) => callback(res))
        .catch((e) => err(e));
    },
    loadMessages(room_id) {
      if (this.messages.page) {
        this.messages.page += 1;
      } else {
        this.messages.page = 1;
        this.showSpinner = true;
      }

      if (
        this.messages.page > 1 &&
        this.messages.page > this.messages.total_pages
      ) {
        return;
      }

      const messagesParams = {
        params: { page: this.messages.page, limit: this.pageLimit.messages },
        role: this.role,
        room_id: room_id,
      };

      this.getMessagesList(messagesParams)
        .then((res) => {
          if (!this.messages.messages) {
            this.messages = res;
            this.showSpinner = false;
          } else {
            this.messages.messages = [
              ...this.messages.messages,
              ...res.messages,
            ];
            if(res.page === res.total_pages) 
              this.endOfMessages = true;
          }
        })
        .catch(e => {
          console.log(e, e.response)
        });
    },
    selectMessage(message) {
      this.showDeleteIcon = true;
      this.selectedMessage = message;
    },
    deleteSelectedMessage() {
      this.popup.isOpen = true;
      this.popup.type = "delete";
    },
    confirmDeleteSelectedMessage() {
      this.showSpinner = true;
      const params = {
        message_id: this.selectedMessage.id,
        role: this.role,
        room_id: this.selectedRoom.id,
      };
      this.deleteMessage(params)
        .then(() => {
          this.selectedMessage.deleted = true;
        })
        .then(() => {
          this.showSpinner = false;
          this.popup.isOpen = false;
          this.popup.type = "";
          this.selectedMessage = {};
        })
        .catch(e => {
          console.log(e, e.response)
        });
    },
    updateEverything(createdRoom) {
      this.endOfMessages = false;
      if (createdRoom) {
        this.selectedRoom = createdRoom;
      }
      this.messages = {};
      this.loadMessages();
      
    },
    getFullName(person) {
      if (person.full_name) return person.full_name;
      else return person.first_name + " " + person.last_name;
    },
    isEmptyObj(obj) {
      return Object.keys(obj).length === 0;
    },
    setShowSpinner(val) {
      this.showSpinner = val;
    },
    setShowDeleteIcon(val) {
      this.showDeleteIcon = val;
    },
  },
  watch: {
    selectedRoom(room) {
      this.messages = {};
      if (!room.isFaked) this.loadMessages(room.id);
    },
    messages() {
      this.userData();
    },
    clientFeatures(val) {
      if(!val.is_messaging_enabled) {
        this.$router.push('/');
      } else {
        this.showSpinner = false;
      }
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/general/mixins.scss" as *;
@use "@/assets/scss/framework/scss-variables.scss" as *;
@use "@/assets/scss/pages/common/_messages.scss";
</style>